import React, { Fragment, useEffect, useState } from 'react';
export function Countdown() {
  const [seconds, setSeconds] = useState(85947);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: [string, number][] = [['HOURS', Math.floor(seconds / 3600)], ['MINUTES', Math.floor(seconds % 3600 / 60)], ['SECONDS', seconds % 60]];
  return <div className="flex justify-center gap-2 sm:gap-4" aria-label="The offer ends soon" data-id="element-389" data-mp="1oh6l8r31vgmw">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-390" data-mp="1xga53xa1k02g" data-mpi={index}>
          {index > 0 && <span className="pt-3 text-2xl font-black text-blue-950/40 sm:pt-4 sm:text-4xl" data-id="element-391" data-mp="1xdp4tcpe5s6t">:</span>}
          <div className="min-w-[76px] rounded-xl border-2 border-blue-950 bg-blue-950 px-3 py-2.5 text-center shadow-sm sm:min-w-[104px] sm:px-5 sm:py-3" data-id="element-392" data-mp="38v70rq0qdnis">
            <div className="text-3xl font-black leading-none text-amber-400 sm:text-5xl" data-id="element-393" data-mp="34t24skmt8esz">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1 text-[10px] font-extrabold tracking-wider text-slate-300" data-id="element-394" data-mp="2h68jia54aupg">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}